export function createListWorkbook(XLSX, rows, columns, sheetName) {
  const values = [columns.map(column => column.label), ...rows.map(row => columns.map(column => {
    const value = column.value(row);
    return value == null ? '' : typeof value === 'number' ? value : String(value);
  }))];
  const sheet = XLSX.utils.aoa_to_sheet(values);
  sheet['!cols'] = columns.map(column => ({ wch: column.width || 22 }));
  sheet['!autofilter'] = { ref: sheet['!ref'] };
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, sheetName);
  return workbook;
}
export async function downloadListExcel(rows, columns, sheetName, filename) {
  const XLSX = await import('xlsx');
  const workbook = createListWorkbook(XLSX, rows, columns, sheetName);
  XLSX.writeFile(workbook, `${filename}.xlsx`, { compression: true });
}
